<template>
  <jet-dialog-modal icon="fas fa-credit-card" id="cardModal">
    <template #title>New Card</template>
    <template #content>
      <div class="form-group">
        <label class="mb-0" for="cardNumber">Card Number <i class="fas fa-asterisk text-danger"></i></label>
        <input placeholder="ex: 4242 5476 4254 5464" v-cardformat:formatCardNumber class="form-control" v-model="formCard.card_number" id="cardNumber" autocomplete="cc-number" x-autocompletetype="cc-number" ref="cc_number"/>
      </div>
      <div class="row">
        <div class="form-group col-sm-5">
          <div class="d-flex">
            <div>
              <label class="mb-0" for="cardExpirationMonth">
                Date Mo <i class="fas fa-asterisk text-danger"></i>
              </label>
              <input 
                placeholder="MM"
                class="form-control d-inline-block"
                maxlength="2"
                autocomplete="cc-exp-month"
                v-model="formCard.card_exp_month"
                id="cardExpirationMonth"
                @keyup="focusYear"
              />
            </div>
            <span class="mx-1 slash d-flex align-items-end">/</span>
            <div>
              <label class="mb-0" for="cardExpirationYear">
                Date Yr <i class="fas fa-asterisk text-danger"></i>
              </label>
              <input
                placeholder="YY"
                class="form-control d-inline-block"
                maxlength="2"
                autocomplete="cc-exp-year"
                v-model="formCard.card_exp_year" 
                id="cardExpirationYear"
              />
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-3 mt-2">
      <div class="row">
        <div class="form-group col-sm-5">
          <label class="mb-0" for="card-holder-name">Name on Card</label>
          <input id="card-holder-name" class="form-control" type="text"
                autocomplete="cc-name" x-autocompletetype="cc-name" v-model="formCard.card_name"/>
        </div>
        <div class="form-group col-sm-3 col-5">
          <label class="mb-0" for="cvc2">Security Code</label>
          <InputMask mask="999?9" slotChar=" " :autoClear="false" placeholder="ex: 243" class="form-control" autocomplete="cc-csc" id="cvc2" type="text" v-model="formCard.card_cvc"/>
        </div>
        <div class="form-group col-sm-4 col-7">
          <label class="mb-0">Zip</label>
          <input class="form-control" type="text" v-model="formCard.card_zip"/>
        </div>
      </div>
    </template>

    <template #footer>
      <jet-button icon="fas fa-credit-card" :disabled="formCard.processing" @click="addCard">Add Card</jet-button>
      <jet-danger-button class="ml-2" data-dismiss="modal">Cancel</jet-danger-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetDangerButton from '@/Jetstream/DangerButton'
  import InputMask from 'primevue/inputmask'

  export default {
    emits: ['cardUpdated'],
    components: {
      JetDialogModal,
      JetDangerButton,
      InputMask
    },
    props: {
      formCard: Object,
      routeUrl: String
    },
    methods: {
      addCard() {
        if (this.formCard.processing) return false;

        this.formCard.post(this.routeUrl, {
          preserveScroll: true,
          onSuccess: () => {
            if (!this.$page.props.flash.error) {
              this.formCard.reset(
                'card_name',
                'card_number',
                'card_exp_month',
                'card_exp_year',
                'card_cvc',
                'card_zip'
              )
             $('#cardModal').modal('hide')
            }
            this.$emit('cardUpdated')
          }
        })
      },
      focusYear(event) {
        if (event.target.value.length >= 2) document.getElementById('cardExpirationYear').focus()
      }
    },
  }
</script>

<style scoped>
  #cardModal input {
    height: 30px;
  }

  .fa-asterisk {
    font-size: 9px;
  }

  #cardModal .slash {
    font-weight: bold;
    font-size: 20px;
  }
</style>


